module.exports = __webpack_public_path__ + "img/phone.ae4083c8.svg";